import React, { useContext } from 'react';
import { Button, Group, Text, Image, Grid, AppShell, Stack } from '@mantine/core';
import MoaSearchField from '../Search/MoaSearchField';
import IndicationFilterField from '../Search/IndicationFilterField';
import bi_logo from '../../assets/logo/bi.svg'
import jku_logo from '../../assets/logo/jku-dark.png'
import vds_logo from '../../assets/logo/vds-dark.png'
import { PiTreeView } from 'react-icons/pi';
import UiStateContext from '../../providers/UiStateProvider';
import RunPicker from './RunPicker';
import UserSelectionContext from '../../providers/UserSelectionProvider';

const Header = () => {
    const { SwitchMeshPanelOpened, meshPanelOpened, SwitchDetailsPanelOpened, detailsPanelOpened } = useContext(UiStateContext)
    const { selectedMoa } = useContext(UserSelectionContext)

    const optionSelected = (option: string) => {
        // console.log(option)
    }
    return (
        <AppShell.Header style={{ backgroundColor: "#34354a", padding: 12 }}>
            <Grid align='center' style={{ height: "100%" }}>
                <Grid.Col span={3}><Text style={{ fontFamily: 'Source Code Pro, monospace' }} size='xl' c="#f3f3f7" fw={500}>mol<span style={{ color: '#47d0ae' }}>IE</span>re<span style={{ color: '#fdb812' }}>VIS</span></Text></Grid.Col>
                <Grid.Col span={6}>
                    <Stack gap={2} style={{ height: "100%" }}>
                        <Grid>
                            <Grid.Col span={11}>
                                <MoaSearchField onOptionSelect={optionSelected} />
                            </Grid.Col>
                            <Grid.Col span={1} style={{ padding: 0 }}>
                                <RunPicker />
                            </Grid.Col>
                        </Grid>
                        <Grid>
                            <Grid.Col span={11}>
                                <IndicationFilterField onOptionSelect={optionSelected} />
                            </Grid.Col>
                            <Grid.Col span={1} style={{ padding: 0 }}>
                                <Button
                                    disabled={!selectedMoa}
                                    leftSection={<PiTreeView size={20} />}
                                    variant='transparent'
                                    style={{
                                        padding: 0,
                                        color: !meshPanelOpened ? "#f3f3f7" : "#fcc419",
                                        background: 'transparent',
                                        opacity: !selectedMoa ? 0.6 : 1
                                    }}
                                    onClick={() => {
                                        if (detailsPanelOpened) {
                                            SwitchDetailsPanelOpened();
                                        }
                                        SwitchMeshPanelOpened();
                                    }}>
                                    MeSH
                                </Button>
                            </Grid.Col>
                        </Grid>
                    </Stack>
                </Grid.Col>
                <Grid.Col span={3}>
                    <Group justify="flex-end">
                        <Image src={jku_logo} style={{ width: "100%", maxWidth: "90px"}} />
                        <Image src={vds_logo} style={{ width: "100%", maxWidth: "90px" }} />
                        <Image src={bi_logo} style={{ width: "100%", maxWidth: "90px" }} />
                    </Group>
                </Grid.Col>
            </Grid>
        </AppShell.Header>
    );
};

export default Header;
